import { AboutLocalInfo } from "@components/dev-features-dialog/about-local-info";
import { Box, Stack } from "@mui-wrapper";
import { DevFeaturesPanel } from "@components/dev-features-dialog/dev-features-panel";
import { DevPagesPanel } from "@components/dev-features-dialog/dev-pages-panel";

interface Props {
  /** Callback invoked when the user navigates to a page, used to close the dialog */
  onNavigate: () => void;
}

/**
 * Content for the Dev Features Dialog.
 * Displays the features/tools table and app version info.
 */
export function DevFeaturesDialogContent({
  onNavigate,
}: Props): React.JSX.Element {
  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={2}>
        {/* Navigable pages */}
        <DevPagesPanel onNavigate={onNavigate} />

        {/* Dev tools and Features Tables */}
        <DevFeaturesPanel />

        {/* App version and commit info for local development */}
        <Box sx={{ mt: 0.25 }}>
          <AboutLocalInfo />
        </Box>
      </Stack>
    </Box>
  );
}
